<template>
  <div>
    <form class="pb-2" @submit.prevent="sendcomments" v-if="comment_permission">
      <!-- <h3>Commenti {{ comments.length }}</h3> -->

      <div class="form-group">
        <textarea
          class="form-control mention"
          name="testo"
          id="cipriani-text-comment"
          placeholder="Scrivi il commento"
          v-model="formcomment.text"
          required
        ></textarea>
        <div class="alert alert-danger" v-if="errorsmessage.text">
          {{ errorsmessage.text[0] }}
        </div>
      </div>
      <!-- End .form-group -->
      <input
        type="file"
        class="neurohub-input-files"
        ref="fileInput"
        multiple
        @change="handleFileUpload"
        accept="image/jpeg, image/png, application/pdf, application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint"
      />
      <!-- onchange="changeAttachmentComment()" -->
      <div class="float-right">
        <button
          type="submit"
          class="btn btn-outline-primary-2 btn-order btn-block"
        >
          Pubblica il commento
        </button>
      </div>
    </form>
  </div>
</template>
<script>
import httpauth from "@/services/httpauth.js";
export default {
  name: "CommentFormComponent",
  props: [
    "activity_id",
    "successmessagecomment",
    "errorMessageComment",
    "loadComments",
    "comment_permission",
  ],
  data() {
    return {
      selectedFilesComments: [],
      errorsmessage: [],
      formcomment: {
        activity_id: this.activity_id,
        text: "",
      },
    };
  },
  mounted() {},
  methods: {
    handleFileUpload(event) {
      this.selectedFilesComments = Array.from(event.target.files);
    },
    async sendcomments() {
      this.formcomment.activity_id = this.activity_id;
      await httpauth
        .post("/comments/store", this.formcomment)
        .then((response) => {
          if (this.selectedFilesComments.length > 0) {
            this.uploadAttachmentsComment(
              response.data.message,
              response.data.id
            );
            return;
          }
          this.$emit("setSuccessMessage", response.data.message);

          this.loadComments();
          this.formcomment.text = "";
        })
        .catch((error) => {
          console.log(error);
          if (error.response !== undefined) {
            this.errorsmessage = error.response.data.errors;
          }
        });
    },
    uploadAttachmentsComment(successMessageContent, commentId) {
      const formData = new FormData();

      this.selectedFilesComments.forEach((file) => {
        formData.append("files[]", file);
      });
      this.selectedFilesComments = null;
      formData.append("model_id", commentId);
      formData.append("model", "comment");
      formData.append("multiple_file", 1);
      formData.append("returned", 0);
      httpauth
        .post("/attachments/store", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          this.$emit("setSuccessMessage", response.data.message);
          this.selectedFilesComments = [];
          this.formcomment.text = "";
          var elements = document.querySelectorAll(".neurohub-input-files");
          for (var i = 0; i < elements.length; i++) {
            elements[i].value = "";
          }
          if (!response.data.status) {
            this.$emit(
              "setErrorMessage",
              "Commento pubblicato ma caricamento degli allegati fallito"
            );
          }
          this.loadComments(this.activity_id);
        })
        .catch((error) => {
          console.log(error.response.data.errors);
          this.$emit(
            "setErrorMessage",
            "Commento pubblicato ma caricamento degli allegati fallito"
          );
          this.loadComments(this.clinicalCase.id);
        });
    },
    /*async loadComments() {
      await httpservices
        .loadComments(this.activity_id)
        .then((response) => {
          this.comments = response.data.data;
        })
        .catch((error) => {
          this.errors = error.response.data.errors;
        });
    },*/
  },
};
</script>